import React, { memo, useRef } from 'react';
import { Text, Box } from 'rebass';
import useOnClickOutside from 'use-onclickoutside';
import { findHTMLFragment } from './htmlFinder';
import { checkIsIpadUser } from 'story-media/hooks';
// import { usePageContext } from 'collections/book-creation/PageContext';

function NewTextLayer({
    zoom,
    value,
    isFromBookCover,
    renderedAsChild,
    randomBorder,
    selectedLayer,
    layerId,
    hidePositionCoordinates,
    setSelectedLayer,
    currentPage,
    ...props
}) {
    const fontSize = props?.fontSize?.replaceAll('px', '');
    // const { currentPage } = usePageContext()
    const isIpadUser = checkIsIpadUser();
    const notOriginalOne = hidePositionCoordinates && props.addID === 'NORMAL ONE';
    const showCursor = props?.kind === "user" && props?.onMediaClick && props?.pageId === currentPage?.id;

    const pickerRef = useRef(null);

    useOnClickOutside(pickerRef, (event) => {
        if (pickerRef.current && pickerRef.current.contains(event.target)) {
            return;
        }
        if (setSelectedLayer && selectedLayer?.id === layerId) {
            const { found } = findHTMLFragment(event.target, pickerRef.current);
            if (!found && event.target.textContent.trim() !== props?.storyDetails && event.target.textContent.trim() !== "Edit Text")
                setSelectedLayer(null)
        }
    });

    const onClick = () => {
        if (props?.isFromPossibilityReview) return;

        if (setSelectedLayer && selectedLayer?.id === layerId) {
            setSelectedLayer(null);
        } else if (showCursor && setSelectedLayer) {
            setSelectedLayer(props);
        }
    }


    if (!props?.text) return null;

    return (<Box
        onClick={onClick}
        ref={pickerRef}
    >
        {selectedLayer && selectedLayer?.id === layerId && <Box
            width={`${props.width}px`}
            height={`${props.height}px`}
            bg='rgba(125, 194, 255, 0.50)' sx={{
                position: (isFromBookCover || renderedAsChild) ? 'relative' : 'absolute',
                cursor: (showCursor || props?.isFromPossibilityReview) ? 'pointer' : 'default',
                left: `${props?.['relative-xpos']}px`,
                top: `${props?.['relative-ypos']}px`,
                zIndex: props['render-order'] + 1,
            }} />}
        <Text
            id={props?.id}
            sx={{
                position: (isFromBookCover || renderedAsChild) ? 'relative' : 'absolute',
                writingMode: 'horizontal-tb',
                fontFeatureSettings: `"kern" 0,"calt" 0,"liga" 0,"clig" 0,"dlig" 0,"hlig" 0`,
                WebkitFontSmoothing: 'subpixel-antialiased',
                MozOsxFontSmoothing: 'grayscale',
                WebkitTextSizeAdjust: 'auto',
                MozTextSizeAdjust: 'auto',
                msTextSizeAdjust: 'auto',
                textSizeAdjust: 'auto',
                contain: 'style',
                direction: 'ltr',
                fontSize: isIpadUser ? `${(fontSize / 100) * zoom}px` : `${fontSize}px`,
                // fontSize: `${fontSize}px`,
                lineHeight: props?.['font-line-height']
                    ? `${props['font-line-height']}px`
                    : 'normal',
                fontFamily: `${props?.fontFamily} !important`,
                fontWeight: props?.fontWeight,
                fontStyle: props?.fontStyle,
                textAlign: props?.fontAlignment === 'justified' ? 'justify' : props?.fontAlignment,
                textDecoration: props?.['font-decoration'] || 'none',
                color: props?.color,

                ...(props?.['letter-spacing'] &&
                    props?.['letter-spacing'] !== 0
                    ? {
                        letterSpacing: `${props['letter-spacing']}px`,
                    }
                    : {}),

                WebkitFontKerning: 'none',
                fontKerning: 'none',
                fontSynthesis: 'none',
                WebkitFontVariantLigatures: 'none',
                fontVariantLigatures: 'none',
                overflow: 'visible',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',

                width: `${props.width}px`,
                height: `${props.height}px`,
                verticalAlign: props['vertical-alignment'],

                left: notOriginalOne
                    ? `${props?.['relative-xpos']}px`
                    : `${props.xpos}px`,
                top: notOriginalOne
                    ? `${props?.['relative-ypos']}px`
                    : `${props.ypos}px`,

                zIndex: props['render-order'] || 2,
                cursor: showCursor ? 'pointer' : 'default',
                outline: 'none',
                touchAction: 'pan-x pan-y pinch-zoom',
                border: randomBorder,

                // Reset spacing
                padding: '0px !important',
                margin: '0px !important',

                // Tabs
                MozTabSize: '4',
                OTabSize: '4',
                tabSize: '4',

                textTransform: 'none',

                '& p': {

                    marginBlockEnd: 'unset',
                    marginTop: '0 !important',
                    marginBottom: props?.['paragraph_spacing']
                        ? `${props['paragraph_spacing']}px !important`
                        : undefined,

                },
                whiteSpace: 'pre-wrap',
                '& p:last-of-type': {
                    marginBottom: '0 !important',
                },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                    marginTop: '0 !important',
                    marginBottom: props?.['paragraph_spacing']
                        ? `${props['paragraph_spacing']}px !important`
                        : '0 !important',
                    fontFamily: `${props?.fontFamily} !important`,
                    fontWeight: props?.fontWeight,
                    fontStyle: props?.fontStyle,
                    color: props?.color,
                    lineHeight: props?.['font-line-height']
                        ? `${props['font-line-height']}px`
                        : 'normal',
                    textAlign:
                        props?.fontAlignment === 'justified'
                            ? 'justify'
                            : props?.fontAlignment,
                    textDecoration: props?.['font-decoration'] || 'none',
                },

                '& h1:last-of-type, & h2:last-of-type, & h3:last-of-type, & h4:last-of-type, & h5:last-of-type, & h6:last-of-type': {
                    marginBottom: '0 !important',
                },
            }}
            dangerouslySetInnerHTML={{
                __html: props.text.replace(/\n\n+/g, '\n'),
            }}
        />
    </Box>
    );
}

export default memo(NewTextLayer);
